module.exports = {"pathContext":{"name":"EmailStatus","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"email","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"status","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"This is the delivery status of the email. This infomation is obtained via SendGrid.","enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-email-status.json
// module id = 1769
// module chunks = 197700538259302